import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { ADD, PAYMENT_BUY } from "const"
import { MtCartCreate } from "server/models"
import { completePaymentRoute, mtBillingRoute } from "client/parts/routes"
import { hasAccess, replaceHistoryState } from "client/utils"
import {
    PRM_BILLING,
    StoreType,
    CreateCartData,
    setBillingReloadCart,
} from "client/store"
import { PageForm, Button } from "client/components"

import AvailablePackages from "./availablePackages"
import CompletePayment from "./completePayment"

const SubscriptionButton = () => {
    const activePackage = useSelector((state: StoreType) => state.system.packageActive)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [showModal, setShowModal] = useState(false)
    const [showCompletePayment, setShowCompletePayment] = useState(false)

    useEffect(() => {
        const { pathname } = window.location
        if (pathname.includes(completePaymentRoute)) {
            setShowCompletePayment(true)
        }
    }, [])

    const useCurrentSubscription = () => {
        const cartData: MtCartCreate = {
            accountId: userData.accountId,
            userId: userData.userId,
            packageIdFrom: activePackage.packageId,
            packageIdTo: activePackage.packageId,
            packageAction: PAYMENT_BUY,
            librarySetId: null,
            projectId: null,
        }
        CreateCartData(cartData).then(() => {
            dispatch(setBillingReloadCart(false))
            setTimeout(() => {
                dispatch(setBillingReloadCart(true))
            }, 0)
        })
    }

    const closeCompletePayment = () => {
        setShowCompletePayment(false)
        replaceHistoryState(mtBillingRoute)

        dispatch(setBillingReloadCart(false))
        setTimeout(() => {
            dispatch(setBillingReloadCart(true))
        }, 0)
    }

    const addAccess = hasAccess(PRM_BILLING, ADD)

    if (userData.accountId === 1) return null // only for account holders
    return (
        <PageForm>
            {
                addAccess && (
                    <Row>
                        <Col xs={12}>
                            <Button variant="success" row uppercase={false} onClick={() => setShowModal(true)}>
                                {lang.changeUpgradeSubscription}
                            </Button>
                            {
                                /*
                                // TODO: temporarily disabled
                                activePackage.packageId !== 1 && ( // not "demo" package
                                    <Button variant="success" row uppercase={false} onClick={useCurrentSubscription}>
                                        {lang.payForSubscription}
                                    </Button>
                                )
                                */
                            }
                        </Col>
                    </Row>
                )
            }

            <AvailablePackages
                show={showModal}
                onClose={() => setShowModal(false)}
            />

            <CompletePayment
                show={showCompletePayment}
                onClose={closeCompletePayment}
            />
        </PageForm>
    )
}
export default SubscriptionButton
